.inner {
  &[data-with-left-section="true"] {
    margin-inline-end: 0.5em;
  }
}

.root {
  border-radius: var(--mantine-radius-sm);
  &[data-with-left-section="true"] {
    [data-position="left"] {
      margin-inline-end: 5px;
    }
  }
}

.root[disabled][data-variant="tertiary"] {
  background-color: transparent;
  color: var(--mantine-color-gray-4);
}

.root[disabled][data-variant="tertiary-critical"] {
  background-color: transparent;
  color: var(--mantine-color-gray-4);
}

.root[data-disabled="true"][data-variant="primary"] {
  background-color: var(--primary-disabled-color);
  /* background-color: var(--primary-disabled-color); */
  color: var(--mantine-color-white);
}

.root[data-disabled="true"][data-variant="primary-critical"] {
  background-color: var(--mantine-color-red-2);
  color: var(--mantine-color-white);
}
.root[data-disabled="true"][data-variant="secondary"] {
  color: var(--primary-disabled-color);
  background-color: var(--mantine-color-white);
  border-color: var(--primary-disabled-color);
}

.root[data-variant*="tertiary"] {
  text-decoration: underline;
}

.menuControl {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border: 0;
  border-left: rem(1px) solid var(--mantine-color-body);
}

.splitButton {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
